export default __webpack_public_path__ + "static/media/DizbuzzHome.cca4859b.png";